import { DefaultButton, Dialog, DialogFooter, MessageBar, MessageBarType, PrimaryButton, TextField } from '@fluentui/react';
import React from 'react';
import { useTestSmtpMutation } from '../../../store/endpoints/StorefrontSettingsEndpoints';

interface ISmtpTestDialogProps {
    isOpen: boolean;
    onDismiss: () => void;
}

const SmtpTestDialog: React.FC<ISmtpTestDialogProps> = (props) => {
    const [recipient, setRecipient] = React.useState<string>('');
    const [sending, setSending] = React.useState<boolean>(false);
    const [result, setResult] = React.useState<{ success: boolean; error?: string } | undefined>(undefined);
    const [testSmtp] = useTestSmtpMutation();

    const close = () => {
        if (sending) return;
        setRecipient('');
        setResult(undefined);
        props.onDismiss();
    };

    const send = async () => {
        if (sending || !recipient) return;
        setSending(true);
        setResult(undefined);
        try {
            const response = await testSmtp({ recipient }).unwrap();
            setResult({ success: response.success, error: response.error });
        } catch {
            setResult({ success: false, error: 'Failed to send test email' });
        } finally {
            setSending(false);
        }
    };

    return (
        <Dialog
            hidden={!props.isOpen}
            onDismiss={close}
            dialogContentProps={{
                title: 'Send Test Email',
                showCloseButton: true,
            }}
        >
            <TextField
                label='Recipient'
                value={recipient}
                onChange={(_e, value) => setRecipient(value ?? '')}
                disabled={sending}
                placeholder='name@example.com'
            />
            {result && (
                <MessageBar
                    messageBarType={result.success ? MessageBarType.success : MessageBarType.error}
                    styles={{ root: { marginTop: '1em' } }}
                >
                    {result.success ? 'Test email sent successfully.' : (result.error || 'Failed to send test email.')}
                </MessageBar>
            )}
            <DialogFooter>
                <PrimaryButton text='Send' onClick={send} disabled={sending || !recipient} />
                <DefaultButton text='Close' onClick={close} disabled={sending} />
            </DialogFooter>
        </Dialog>
    );
};

export default SmtpTestDialog;
